import { observer } from 'mobx-react-lite';
import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_PlayerStore } from './PlayerStore';

export const SearchView = observer(function SearchView() {
  const store = useResolve(TOKEN_PlayerStore);
  const i18n = useResolve(TOKEN_II18n);
  if (!store.isSearchOpen) return null;

  return (
    <div className="fixed inset-0 z-20 flex flex-col" role="dialog" aria-label={i18n.t('player.search')}>
      <div className="flex-1 bg-ink/30" onClick={store.closeSearch} />
      <div className="flex max-h-[70vh] flex-col rounded-t-3xl border-t border-line bg-surface">
        <div className="flex items-center gap-2 border-b border-line p-3">
          <MagnifyingGlass size={18} className="ml-1 shrink-0 text-muted" />
          <input
            type="search"
            autoFocus
            value={store.searchQuery}
            onChange={(e) => store.setSearchQuery(e.target.value)}
            placeholder={i18n.t('search.placeholder')}
            className="min-w-0 flex-1 bg-transparent px-1 py-2 text-sm text-ink outline-none placeholder:text-muted"
          />
          <button
            type="button"
            onClick={store.closeSearch}
            className="flex h-8 w-8 items-center justify-center rounded-full text-muted hover:bg-line/60 hover:text-ink"
            aria-label={i18n.t('common.close')}
          >
            <X size={18} />
          </button>
        </div>

        <ul className="min-h-0 flex-1 overflow-y-auto p-2">
          {store.searchQuery.trim() !== '' && store.searchResults.length === 0 && (
            <li className="px-3 py-8 text-center text-sm text-muted">{i18n.t('search.none')}</li>
          )}
          {store.searchResults.map((match, index) => (
            <li key={index}>
              <button
                type="button"
                onClick={() => store.jumpTo(match)}
                className="flex w-full flex-col gap-1 rounded-lg px-3 py-2.5 text-left transition-colors hover:bg-line/50"
              >
                <span className="truncate text-xs tracking-wide text-muted uppercase">
                  {match.chapterLabel}
                </span>
                <span className="font-serif text-sm text-ink">{match.snippet}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
});
